import { render, staticRenderFns } from "./TablePitchesRow.vue?vue&type=template&id=8bd305c2"
import script from "./TablePitchesRow.vue?vue&type=script&lang=js"
export * from "./TablePitchesRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports